import { call, put } from 'redux-saga/effects';

import onlineSalesAction from './onlineSales.types.js';

export function* HANDLE_STATE({ field, value }) {
    yield put({
        type: onlineSalesAction.SET_STATE,
        payload: {
            [field]: value,
        },
    });
}

export function* SET_LOADING(loading = false) {
    yield call(HANDLE_STATE, { field: 'loading', value: loading });
}

export function* SET_LOADING_STATE(field, loading = false) {
    yield call(HANDLE_STATE, { field, value: loading });
}

export function* SET_ERROR() {
    yield call(SET_LOADING);
}

export const doHandleState = (field, value) => ({
    type: onlineSalesAction.HANDLE_STATE,
    field,
    value,
});

export const doSetData = (payload) => ({
    type: onlineSalesAction.HANDLE_STATE,
    field: 'data',
    value: payload,
});

export const doGetProductsAvailability = (payload) => ({
    type: onlineSalesAction.GET_PRODUCTS_AVAILABILITY,
    payload,
});

export const doGetProductsDaysAvailability = (payload) => ({
    type: onlineSalesAction.GET_PRODUCTS_DAYS_AVAILABILITY,
    payload,
});

export const doHandleAddToCart = (payload, onSuccess) => ({
    type: onlineSalesAction.ADD_TO_CART,
    payload,
    onSuccess,
});

export const doHandleDeleteItemCart = (payload) => ({
    type: onlineSalesAction.DELETE_ITEM_CART,
    payload,
});

export const doHandleUpdateItemCart = (payload, onSuccess) => ({
    type: onlineSalesAction.UPDATE_ITEM_CART,
    payload,
    onSuccess,
});

export const doHandleCreateOrder = (payload) => ({
    type: onlineSalesAction.CREATE_ORDER,
    payload,
});

export const doHandleGetBrands = (brandCode, onSuccess) => ({
    type: onlineSalesAction.GET_BRANDS,
    payload: {
        brandCode,
        onSuccess,
    },
});

export const doHandleGetOutlet = () => ({
    type: onlineSalesAction.GET_OUTLET,
});

export const doGetHistoryTransaction = () => ({
    type: onlineSalesAction.GET_HISTORY_TRANSACTIONS,
});

export const doGetHistoryTransactionDetail = (billNo = '', orderType = 'REGULAR') => ({
    type: onlineSalesAction.GET_HISTORY_TRANSACTION_DETAIL,
    payload: {
        billNo,
        orderType,
    },
});

export const doGetLoyaltyTier = () => ({
    type: onlineSalesAction.GET_LOYALTY_TIER,
});

export const doGetAvailableRewards = () => ({
    type: onlineSalesAction.GET_AVAILABLE_REWARDS,
});

export const doGetPointHistory = () => ({
    type: onlineSalesAction.GET_POINT_HISTORY,
});

export const doGetRedeemHistory = () => ({
    type: onlineSalesAction.GET_REDEEM_HISTORY,
});

export const doTriggerRedeem = (payload, onSuccess) => ({
    type: onlineSalesAction.TRIGGER_REDEEM,
    payload,
    onSuccess,
});
